import React from 'react';
import { BaseIcon } from './BaseIcon';

export const FolderCard = (): JSX.Element => <BaseIcon code="folder-card" />;
